export enum PartecipantRoles {
    PrimaryClient = 'PrimaryClient',
    SecondaryClient = 'SecondaryClient',
    GuestClient = 'GuestClient',
    SuperClient = 'SuperClient'
}


export const OPERATOR_ROLES = [PartecipantRoles.PrimaryClient, PartecipantRoles.SuperClient];